import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { IonButton, IonIcon } from "@ionic/react";
import { warningOutline } from "ionicons/icons";
import { getEditAppBaseUrl } from "../../../config/edit-app.config";
import "./migration-banner.component.scss";

export const MigrationBannerComponent: FunctionComponent = () => {
  const { t } = useTranslation();

  const newInterfaceUrl = `${getEditAppBaseUrl()}/edit`;

  return (
    <aside
      className="migration-banner"
      aria-label={t("sites.migrationBanner.importantLabel")}
    >
      <IonIcon
        className="migration-banner__icon"
        icon={warningOutline}
        aria-hidden="true"
      />
      <div className="migration-banner__content">
        <p className="migration-banner__text">
          <strong>{t("sites.migrationBanner.importantLabel")}</strong>{" "}
          {t("sites.migrationBanner.intro")}{" "}
          <strong>{t("sites.migrationBanner.reinstall")}</strong>.{" "}
          {t("sites.migrationBanner.beforeUninstall")}{" "}
          <strong>{t("sites.migrationBanner.syncAnnotations")}</strong>{" "}
          {t("sites.migrationBanner.offlineSuffix")}
        </p>
        <IonButton
          className="migration-banner__button"
          href={newInterfaceUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#FFFFFF",
            "--background": "#FF2953",
            "--padding-start": "12px",
            "--padding-end": "12px",
            textTransform: "none",
            margin: "0",
          }}
        >
          {t("sites.migrationBanner.newInterfaceButton")}
        </IonButton>
      </div>
    </aside>
  );
};
